import { Box, Link } from '@mui/material';
import React from 'react';

const PrivacyTnC = () => {
  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '.6875rem',
      color: 'var(--zoosk-light-blue)'
    }}>
      <span>
        <Link component={'a'} href={'https://www.withlocals.com/info/terms-and-conditions/'} sx={{ color: 'var(--zoosk-light-blue)' }}>
          Terms & Conditions
        </Link>
          &nbsp;&bull;&nbsp;
        <Link component={'a'} href={'https://www.withlocals.com/info/privacy-policy/'} sx={{ color: 'var(--zoosk-light-blue)' }}>
           Privacy policy
        </Link>
      </span>
    </Box>
  )
};

export default PrivacyTnC;